import AuthorizingVet from "./AuthorizingVet";

export default AuthorizingVet;
